import GarminPoint from '../../GarminBuilder/models/GarminPoint.js';

class StravaPoint extends GarminPoint {
  constructor(lat, lon, options = {}) {
    super(lat, lon, options);
    const {
      power,
      cad,
      distance
    } = options;
    this.extensions = { ...this.extensions,
      ...(power != null ? {
        power
      } : {}),
      ...(cad != null ? {
        cadence: cad
      } : {}),
      ...(distance != null ? {
        distance
      } : {})
    };
  }

}

export { StravaPoint as default };
